import React from "react";
import { Nav, Button } from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { BoxArrowRight, PersonCircle, House, Truck, PlusCircle, Moon, Sun, People, FileSpreadsheet, Table} from "react-bootstrap-icons";


const Navi = ({ tema, toggleTema, restrans }) => {
  const location = useLocation();
  const { user, logout } = useAuth();

  const NavItem = ({ to, icon: Icon, label, colorClass = "" }) => (
    <Nav.Item>
      <Nav.Link
        as={Link}
        to={to}
        active={location.pathname === to}
        className={`d-flex align-items-center custom-nav-link ${colorClass} ${
          restrans ? "justify-content-center" : ""
        }`}
        style={{ height: "45px" }}
      >
        <Icon size={20} style={{ minWidth: "20px" }} />
        {!restrans && (
          <span className="ms-3 text-nowrap opacity-fade-in">{label}</span>
        )}
      </Nav.Link>
    </Nav.Item>
  );

  return (
    <div
      className={`d-flex flex-column p-2 h-100 justify-content-between ${restrans ? "sidebar-restrans" : ""}`}
    >
      {/* SECȚIUNEA 1: NAVIGARE */}
      <div className="div-nav-scroll flex-grow-1 mb-3">
        <Nav variant="pills" className="flex-column gap-1">
          <NavItem to="/" icon={House} label="Panou central" />
          <NavItem
            to="/situatie-exploatare"
            icon={Table}
            label="Situație exploatare"
          />
          <NavItem to="/prestari" icon={Truck} label="Vezi contracte" />
          <NavItem
            to="/tabelPartizi"
            icon={FileSpreadsheet}
            label="Vezi partizi"
          />
          <NavItem
            to="/adaugPartida"
            icon={PlusCircle}
            label="Adaugă partizi"
          />
          <NavItem to="/adaug" icon={PlusCircle} label="Adaugă contract" />

          {user?.rol === "administrator" && (
            <>
              <div className="border-top my-2 opacity-25"></div>
              <NavItem
                to="/admin-utilizatori"
                icon={People}
                label="Utilizatori"
              />
            </>
          )}
        </Nav>
      </div>
      {/* SECȚIUNEA 2: SETĂRI ȘI PROFIL  */}
      <div className="sectiune-footer-nav pt-3 border-top d-flex flex-column gap-2">
        <div
          className={`d-flex align-items-center mb-2 ${
            restrans ? "justify-content-center w-100" : "px-1"
          }`}
        >
          {!restrans ? (
            <div className="d-flex bg-soft-fused p-1 rounded-3 gap-1 w-100">
              <Button
                variant="transparent"
                className={`w-50 py-1 d-flex align-items-center justify-content-center btn-tema-segment ${
                  tema === "light" ? "active-segment" : ""
                }`}
                onClick={() => tema !== "light" && toggleTema()}
              >
                <Sun size={15} className="me-2" />
                <span className="small fw-semibold">Light</span>
              </Button>
              <Button
                variant="transparent"
                className={`w-50 py-1 d-flex align-items-center justify-content-center btn-tema-segment ${
                  tema === "dark" ? "active-segment" : ""
                }`}
                onClick={() => tema !== "dark" && toggleTema()}
              >
                <Moon size={15} className="me-2" />
                <span className="small fw-semibold">Dark</span>
              </Button>
            </div>
          ) : (
            <Button
              variant="transparent"
              onClick={toggleTema}
              className="text-muted p-2 d-flex align-items-center justify-content-center rounded-3 btn-tema-restrans"
              style={{ width: "45px", height: "45px" }}
            >
              {tema === "light" ? (
                <Sun size={20} className="text-warning" />
              ) : (
                <Moon size={20} className="text-info" />
              )}
            </Button>
          )}
        </div>

        {/* Profil Utilizator */}
        <div
          className={`profil-card p-2 d-flex align-items-center ${
            restrans ? "justify-content-center" : "justify-content-start"
          }`}
        >
          <PersonCircle
            size={restrans ? 26 : 22}
            className="text-success flex-shrink-0"
          />
          {!restrans && (
            <div className="ms-3 overflow-hidden opacity-fade-in text-start">
              <p
                className="fw-bold small mb-0 text-truncate"
                style={{ lineHeight: "1.2" }}
              >
                {user?.nume || "Utilizator"}
              </p>
              <p
                className="mb-0 text-muted text-truncate"
                style={{
                  fontSize: "0.65rem",
                  textTransform: "uppercase",
                  letterSpacing: "0.5px",
                }}
              >
                {user?.rol}
              </p>
            </div>
          )}
        </div>

        {/* Buton Ieșire */}
        <Button
          variant="transparent"
          onClick={logout}
          className={`d-flex align-items-center custom-nav-link link-iesire-clean ${
            restrans
              ? "justify-content-center mx-auto"
              : "w-100 justify-content-start"
          }`}
          style={{ height: "45px" }}
        >
          <BoxArrowRight size={20} style={{ minWidth: "20px" }} />
          {!restrans && (
            <span className="ms-3 text-nowrap opacity-fade-in">
              Ieșire din cont
            </span>
          )}
        </Button>
      </div>{" "}
    </div>
  );
};

export default Navi;
